import { useTranslation } from "react-i18next";

const useSingleRoomTranslation = () => {
  const { t } = useTranslation();

  const rooms = [
    {
      name: t("roomsInfoSingles.0.name"),
      title: t("roomsInfoSingles.0.title"),
      roomNumber: "room1",
      description: t("roomsInfoSingles.0.description"),
      persone: 4,
    },
    {
      name: t("roomsInfoSingles.1.name"),
      title: t("roomsInfoSingles.1.title"),
      roomNumber: "room2",
      description: t("roomsInfoSingles.1.description"),
      persone: 3,
    },
    {
      name: t("roomsInfoSingles.2.name"),
      title: t("roomsInfoSingles.2.title"),
      roomNumber: "room3",
      description: t("roomsInfoSingles.2.description"),
      persone: 3,
    },
    {
      name: t("roomsInfoSingles.3.name"),
      title: t("roomsInfoSingles.3.title"),
      roomNumber: "room4",
      description: t("roomsInfoSingles.3.description"),
      persone: 2,
    },
    {
      name: t("roomsInfoSingles.4.name"),
      title: t("roomsInfoSingles.4.title"),
      roomNumber: "room5",
      description: t("roomsInfoSingles.4.description"),
      persone: 3,
    },
  ];

  return rooms;
};

export default useSingleRoomTranslation;
